// @flow
import {
  RESORT_ACCOMMODATION_TYPES,
  RESORT_ACCOMMODATION_EXCLUSIVE_COLLECTION,
} from 'Client/cms/toolkit/constants';
import { ProductAccommodationsLine } from 'Components/lines/product-accommodations-line/ProductAccommodationsLine';
import {
  productAccommodationsResolver,
  productAccommodationsExclusiveCollectionResolver,
} from './productAccommodations.resolver';

export const productAccommodationsDescriptor = {
  name: RESORT_ACCOMMODATION_TYPES,
  component: ProductAccommodationsLine,
  resolve: productAccommodationsResolver.resolve,
};

export const productAccommodationsExclusiveCollectionDescriptor = {
  name: RESORT_ACCOMMODATION_EXCLUSIVE_COLLECTION,
  component: ProductAccommodationsLine,
  resolve: productAccommodationsExclusiveCollectionResolver.resolve,
};
